<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBarClick"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <span class="brand-name">{{ brandName }}</span>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <img
            :src="
              'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80'
            "
            class="user-avatar"
          />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <!-- <router-link to="/">
            <el-dropdown-item>
              Home
            </el-dropdown-item>
          </router-link>
          <a target="_blank" href="https: //  github.com/PanJiaChen/vue-admin-template/">
            <el-dropdown-item>Github</el-dropdown-item>
          </a>
          <a target="_blank" href="https: //  panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a>-->
          <el-dropdown-item divided v-if="isAgent">
            <span style="display:block;" @click="showCompanySwitchDialog">代理公司</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退&nbsp;&nbsp;出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <CompanySwitchDialog
      v-if="companySwitchDialogShow"
      @on-close="closeCompanySwitchDialog"
      @on-sure="sureCompanySwitchDialog"
    ></CompanySwitchDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { mapActions } from 'vuex'
import CompanySwitchDialog from '@/components/companySwitchingDialog'
// import { async } from 'q'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    CompanySwitchDialog
  },
  data() {
    return {
      companySwitchDialogShow: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'brandInfo',
      'isHaveAgentAuth',
      'agentCompanyList',
      'hierarchyType',
      'roleInfo',
      'userInfo',
      'isOpenGxms',
      'groupInfo'
    ]),
    brandName() {
      if (this.hierarchyType === 'MD' && this.isOpenGxms) {
        return this.userInfo.shopName
      } else if (this.hierarchyType === 'JT' && this.isOpenGxms) {
        return this.groupInfo.groupName
      }
      return this.brandInfo.name
    },
    isInitCreat() {
      return this.roleInfo.isInitCreat === '1'
    },
    // 是否具有代理公司
    isAgent() {
      return (
        this.isHaveAgentAuth === '1' &&
        this.agentCompanyList.length > 0 &&
        this.hierarchyType === 'GS' &&
        this.isInitCreat
      )
    }
  },
  methods: {
    ...mapActions([
      'loginOutAction',
      'toggleSideBar',
      'queryAgentCompanyAction'
    ]),
    toggleSideBarClick() {
      // this.$store.dispatch(this.toggleSideBar)
      this.toggleSideBar()
      // this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      //  await this.$store.dispatch('user/logout')
      //  this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      this.$confirm('确定要退出系统吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.loginOutAction({
            t: new Date().getTime()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    showCompanySwitchDialog() {
      this.companySwitchDialogShow = true
    },
    closeCompanySwitchDialog() {
      this.companySwitchDialogShow = false
    },
    sureCompanySwitchDialog() {
      this.companySwitchDialogShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    //  line-height: 50px;
    display: flex;
    align-items: center;

    .brand-name {
      border-right: solid 2px #dedede;
      padding-right: 20px;
      margin-right: 20px;
      opacity: 0.6;
      font-weight: bold;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
